import { useAtomValue, useSetAtom } from 'jotai'
import { useNavigate } from 'react-router-dom'
import ShareOffer from 'src/common/components/ShareOffer/ShareOffer'
import Button from 'src/common/ui-kit/Button/Button'
import Icon from 'src/common/ui-kit/Icon/Icon'
import { useTranslation } from 'react-i18next'
import {
  buyTokenAmountAtom,
  buyTokenAtom,
  sellTokenAmountAtom,
  sellTokenAtom,
  successfulCreatedOfferIdAtom,
} from '../../stores/trade-store'
import { preselectedMyOfferIdAtom } from 'src/pages/DiscoverPage/discover-store'

const LimitSuccess = () => {
  const { t } = useTranslation('trade', { keyPrefix: 'limitSuccess' })
  const navigate = useNavigate()

  const sellToken = useAtomValue(sellTokenAtom)
  const buyToken = useAtomValue(buyTokenAtom)
  const sellTokenAmount = useAtomValue(sellTokenAmountAtom)
  const buyTokenAmount = useAtomValue(buyTokenAmountAtom)
  const successfulCreatedOfferId = useAtomValue(successfulCreatedOfferIdAtom)
  const setPreselectedMyOfferIdAtom = useSetAtom(preselectedMyOfferIdAtom)

  const showShareOffer = sellToken && buyToken && successfulCreatedOfferId

  const handleViewOffers = () => {
    setPreselectedMyOfferIdAtom(successfulCreatedOfferId)
    navigate('/discover/my-offers?offerStatuses=PartiallyTaken,NotTaken')
  }

  const handleBackToTrade = () => {
    navigate('/trade/limit')
  }

  return (
    <>
      <div className='paper p-4 mb-4 flex flex-col justify-center items-center'>
        <Icon
          name='success-status'
          className='mb-2'
          size={35}
          color='primary'
        />
        <div className='typo-title3 text-main-accent mb-4'>
          {t('offerMade')}
        </div>
        {showShareOffer && (
          <ShareOffer
            className='w-full'
            tokenIn={sellToken}
            tokenOut={buyToken}
            amountIn={sellTokenAmount}
            amountOut={buyTokenAmount}
            offerId={successfulCreatedOfferId}
          />
        )}
      </div>
      <div className='flex gap-4'>
        <Button
          className='w-full px-2'
          onClick={handleViewOffers}
          variant='outlined'
        >
          {t('viewMyOffer')}
        </Button>
        <Button className='w-full px-2' onClick={handleBackToTrade}>
          {t('createNewOffer')}
        </Button>
      </div>
    </>
  )
}

export default LimitSuccess
